"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var replacePath = function replacePath(page, actions, originalPath, newPath) {
  if (!newPath || newPath === originalPath) {
    return;
  }

  var createPage = actions.createPage,
      deletePage = actions.deletePage;
  var currentPagePath = page.path;

  if (currentPagePath.match(originalPath)) {
    var oldPage = Object.assign({}, page);
    page.path = currentPagePath.replace(originalPath, newPath);
    createPage(page);
    deletePage(oldPage);
  }
};

exports.default = replacePath;